import { createSelector } from '@ngrx/store';
import { getSharedFeatureState } from '../shared.state';

export class ComponentInfoSelectors {
  private static readonly getComponentInfoState = createSelector(
    getSharedFeatureState,
    (state) => state.componentInfoState
  );

  static readonly getComponentInfo = createSelector(
    ComponentInfoSelectors.getComponentInfoState,
    (state) => state?.componentInfo
  );
  static readonly getError = createSelector(ComponentInfoSelectors.getComponentInfoState, (state) => state?.error);
}
